import { forwardRef } from "react";

import { show } from "@intercom/messenger-js-sdk";
// oxlint-disable-next-line no-restricted-imports
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import { KnowledgebaseIcon } from "@/shared/icons/navbar/KnowledgebaseIcon";
import { SupportIcon } from "@/shared/icons/navbar/SupportIcon";
import { type LANGUAGE_ID } from "@/shared/lang/lang.constants";
import {
  getHelpCenterLang,
  getVersionHistoryUrl,
  helpCenterUrl,
} from "@/shared/services/helpCenter";
import {
  trackHelpVersionHistory,
  trackSupport,
  trackTutorials,
} from "@/shared/services/mixpanel";

import { ContextMenuItem } from "../ContextMenuItem/ContextMenuItem";

type Props = {
  langId: LANGUAGE_ID;
  mobile?: boolean;
  onMenuItemClick?: () => void;
};

const HelpMenu = forwardRef<HTMLDivElement, Props>(
  ({ langId, mobile = false, onMenuItemClick = () => {} }, ref) => {
    const helpCenterLink = helpCenterUrl(getHelpCenterLang(langId));

    return (
      <div ref={ref}>
        <ContextMenuItem
          component={Link}
          icon={<KnowledgebaseIcon />}
          id="help-menu-knowledgebase"
          label={<FormattedMessage id="HelpMenu.knowledgebase" />}
          mobile={mobile}
          target="_blank"
          to={helpCenterLink}
          onClick={() => {
            trackTutorials();
            onMenuItemClick();
          }}
        />
        <ContextMenuItem
          icon={<SupportIcon />}
          id="help-menu-support"
          label={<FormattedMessage id="HelpMenu.support" />}
          mobile={mobile}
          onClick={() => {
            trackSupport();
            onMenuItemClick();
            show();
          }}
        />
        <ContextMenuItem
          component={Link}
          icon={<NewReleasesIcon />}
          id="help-menu-version-history"
          label={<FormattedMessage id="HelpMenu.versionHistory" />}
          mobile={mobile}
          target="_blank"
          to={getVersionHistoryUrl(langId)}
          onClick={() => {
            trackHelpVersionHistory();
            onMenuItemClick();
          }}
        />
      </div>
    );
  },
);

HelpMenu.displayName = "HelpMenu";

export { HelpMenu };
